import React from 'react';
import { LinkCatalog } from 'system/LinkCatalog';

import { QuestionTooltip } from 'reactApp/components/questionTooltip/questionTooltip';
import { Link } from 'reactComponents/Link/Link';

export function QuestionTooltipHighCpu() {
    return (
        <QuestionTooltip
            text={_getTextForTooltipHighCpu()}
            position="right center"
            triggerDataTest="high-cpu-tooltip"
        />
    );
}

function _getTextForTooltipHighCpu() {
    return (
        <>
            Процессоры intel Xeon® E5-2667v4 с тактовой частотой 3.2 GHz для
            выполнения ресурсоемких задач. Для включения обратитесь в{' '}
            <Link
                href={LinkCatalog.getInfraSupportEmail()}
                dataTest="high-cpu-help-link"
            >
                службу поддержки
            </Link>
        </>
    );
}
